import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-input-dialog",
    templateUrl: "./input-dialog.component.html",
    styles: [
        `
      .dialog-container {
        padding: 20px;
        min-width: 350px;
      }
      .dialog-title {
        margin: 0 0 20px 0;
        color: #333;
      }
      input {
        width: 100%;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;
      }
      .dialog-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
      }
    `,
    ],
    standalone: false
})
export class InputDialogComponent {
  form: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<InputDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      input: [""],
    });
  }

  onSave(): void {
    var inputValue: string = this.form.get("input")?.value;
    if (inputValue && inputValue.trim()) {
      this.dialogRef.close(inputValue.trim());
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
